import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import VisualHistoryEventMetadataField, {
  VisualHistoryEventMetadataFieldProps,
} from 'molbio/visual-history/VisualHistoryEventMetadataField';
import getTestProps from 'test/lib/cypress/getTestProps';

interface VisualHistoryEventMetadataFieldListProps {
  fields: Array<VisualHistoryEventMetadataFieldProps>;
}

/**
 * Render a list of metadata fields in a 2 column grid.
 * @param fields List of metadata fields.
 * @constructor
 */
export default function VisualHistoryEventMetadataFieldList({
  fields,
}: VisualHistoryEventMetadataFieldListProps): JSX.Element {
  return (
    <div
      className={css(styles.fieldsContainer)}
      {...getTestProps({component: 'VisualHistoryEventMetadataFieldList', element: 'root'})}
    >
      {fields.map((field, i) => (
        <VisualHistoryEventMetadataField key={i} name={field.name} value={field.value} />
      ))}
    </div>
  );
}

const styles = StyleSheet.create({
  fieldsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px 8px',
  },
});
